import { format } from 'date-fns';

export const routerPath = {
  root: '/vendorOrders',
};

export const getColumns = ({ viewOrder }) => [
  { id: 'orderNumber', label: 'Order Nr', align: 'left', nameForSort: 'number' },
  { id: 'productName', label: 'Product Name', align: 'center', nameForSort: 'p.name' },
  { id: 'status', label: 'Status', align: 'center', nameForSort: 'status' },
  { id: 'quantity', label: 'Items Quantity', align: 'center', disableSort: true },
  {
    id: 'createdAt',
    label: 'Date',
    customValue: (val) => format(new Date(val.createdAt), 'E, dd MMM yyyy p'),
    align: 'center',
    nameForSort: 'created_at',
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [{ id: 1, name: 'Order View', action: viewOrder, icon: 'eva:edit-fill' }],
    disableSort: true,
  },
];

export const getFilters = ({ searchBy, status, dateRange, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by Order number',
    action: searchBy.change,
  },
  {
    id: 'dateRange',
    variant: 'dateTime',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'status',
    type: 'select',
    label: 'Status',
    value: status.value,
    action: status.change,
    items: options?.statuses?.length ? ['all', ...options.statuses] : ['all'],
  },
];
